package amazon.lastmile.inject

import app.nestbridge.app.context.identity.DefaultUserContextProvider
import app.nestbridge.app.context.identity.UserContextProvider
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultUserContextProvider::class)
public interface AppNestbridgeAppContextIdentityDefaultUserContextProvider {
  @Provides
  public fun provideDefaultUserContextProviderUserContextProvider(defaultUserContextProvider: DefaultUserContextProvider): UserContextProvider = defaultUserContextProvider
}
